<template lang="html">

  <div 
    v-if="cell"
    class="cell"  
    :class="{ 'highlight':cell.selected }"  
  >
    <svg 
      viewbox="0 0 100 100"
      v-show="isPlaying || completed"
    >
      <text
        x="50%"
        y="50%"
        dy=".4em"
      >
        {{ cell.letter }}
      </text>
    </svg>    

  </div>

</template>

<script lang="js">

  import { mapGetters, mapState, mapActions } from 'vuex'

  import { debounce } from 'throttle-debounce'

  export default  {
    name: 'cell',

    props: [
      'row',
      'col',
      'cell'
    ],

    methods: {
      ...mapActions({
        startDrag: 'mouseDragger/startDrag',
        dragOver: 'mouseDragger/dragOver',
        endDrag: 'mouseDragger/endDrag',
      }),    
      
    },

    computed: {
      
      ...mapState({
        isPlaying: state => state.game.isPlaying,
        completed: state => state.game.completed,
      }),

    }
  }

</script>

<style scoped lang="scss">
  // TODO move css to a singular cell class file

  @import '@puzzleapps/shared/src/style/variables';
  @import '@puzzleapps/shared/src/style/animations';

  .cell {
    display: flex;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    transform: translateZ(0);
    flex-grow: 1;
    flex-basis: 0;
    align-items: center;
    justify-content: center;
    font-family: $pen-font;
    user-select: none;
    color: var(--pencil-color);
    transition: background 0.07s;
    font-weight: 400;
    z-index: 5;
    overflow: hidden;
    color: #0f1113;

    &.highlight{
      background:#FFE37E;
      border-radius: 25px;

    }

    svg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0%;
      left: 0;

      text {        
        font-family: $pen-font;
        font-size: 1.6rem;
        text-anchor: middle;

        @media (max-width: 768px) {
          font-size: 5vw;
        }
      }
    }

    &:before {
      content: "";
      display: block;
      padding-bottom: 100%;
    }

    &:after {
      z-index: 9;
    }

  }
</style>

